import React from "react";
import authPagesBgImage from "../assets/img/auth/bg.png";

function AuthLayout({ children }) {
  return (
    <main className="main" id="top">
      <div className="container-fluid bg-body-tertiary dark__bg-gray-1200">
        <div
          className="bg-holder bg-auth-card-overlay"
          style={{ backgroundImage: `url(${authPagesBgImage})` }}
        ></div>
        {children}
      </div>
    </main>
  );
}

export default AuthLayout;
